import React, {useEffect, useState} from 'react'
import FailedModal from "../../../CustomModal/Failed";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import useLatLng from "../../../../hooks/uselatlng/uselatlng";
import {toast} from "react-toastify";
import Moment from 'moment';
import DropDownInput from "../../../Input/dropDownInput/dropDownInput";
import SuccessModal from "../../../CustomModal/Success";
import FileUpload from "../../../FileUploads/FileUpload";
import DistanceCalculator from "../../../DistanceCalculator/Calculator";
import {accountByLeadId} from "../../../../service/BA/action";

const BAActivitySave = ({
                            documentUploadUrlPublic,
                            saveActivity,
                            documentUrlDataPublic = [],
                            history,
                            match,
                            getPendingActivity,
                            saveActivityRes = [],
                            activityTypesDetails = [],
                            activityTypes,
                            getSenior,
                            senior = [],
                            pendingActivity = [],
                            markAttendance,
                            attendance = [],
                            isCheckout,
                            isCheckoutDetails = [],
                            accountByLeadId,
                            accountLeadId=[]
                        }) => {

    var now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    const islatlng = useLatLng();
    const [isLoading, setIsLoading] = useState(false)
    const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [inputList, setInputList] = useState([{
        activity_type_id: '',
        activity_date: '',
        meta_data: {},
        lat: '',
        long: '',
        next_activity_type_id: '',
        next_activity_date: '',
        description: '',
        tagged_along: '',
        reason: [{
            primary_product:[],
            add_on_product:[]
        }]
    }])
    const [isActivityCreated, setIsActivityCreated] = useState(false)
    const [activityTypeId, setActivityTypeId] = useState('')
    const [distance, setDistance] = useState(0)
    const [currentDate, setCurrentDate] = useState(now.toISOString().slice(0, 16))
    const [taggedAlonedReportee, setTaggedAlonedReportee] = useState({})
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
    const [openCheckIn, setOpenCheckIn] = useState(false)
    const [checkInText, setCheckInText] = useState('')
    const [reason, setReason] = useState([{}])
    const [addonProduct, setAddonProduct] = useState([{}])

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await accountByLeadId(match?.params?.lead_id !== undefined ? match?.params?.lead_id :'' )
            await activityTypes('is_ba')
            await getSenior()
            await isCheckout('BA', -1)
            setIsLoading(false)
        })()
    }, [])

    const toRad = (Value) => {
        return Value * Math.PI / 180
    }

    useEffect(() => {
        if(accountLeadId?.data !== [] && accountLeadId?.data !== null && Object.keys(accountLeadId).length > 0){
            (async () => {
                await getPendingActivity(accountLeadId?.data?.id)
                await isCheckout('BA', accountLeadId?.data?.id)
            })()
        }else{
            (async () => {
                await getPendingActivity(-1)
            })()
        }
    }, [accountLeadId])

    const calcCrow = (lat1, lon1, lat2, lon2) => {
        var R = 6371 // km
        var dLat = toRad(lat2 - lat1)
        var dLon = toRad(lon2 - lon1)
        var lat1 = toRad(lat1)
        var lat2 = toRad(lat2)

        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2)
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
        var d = R * c
        return d
    }

    const handleInput = (key, val, metaKey, e) => {
        let list = [...inputList]
        if (key === 'meta_data') {
            if (e.target !== undefined && e.target.selectedOptions !== undefined) {
                let desc = e.target.selectedOptions[0].text;
                inputList[0][key][metaKey] = desc
                inputList[0][key][metaKey + "_id"] = val
            } else {
                inputList[0][key][metaKey] = val
            }
        } else {
            inputList[0][key] = val
        }
        setInputList(list)
    }

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (saveActivityRes?.status === 200) {
            setIsSuccessModalOpen(true)
            // window.location.href = `dealer-activity-list/${match?.params?.module_id}`
        } else if (saveActivityRes?.status !== undefined && saveActivityRes?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
        }
    }, [saveActivityRes])

    useEffect(() => {
        let values = ""
        let names = []
        if (taggedAlonedReportee !== [] && taggedAlonedReportee !== '' && taggedAlonedReportee.length > 0) {
            taggedAlonedReportee.map((val, i) => {
                names[i] = val?.name
                if (i === 0) {
                    values = val.id
                } else {
                    values += ',' + val.id
                }
            })
        }
        handleInput('tagged_along', values, '', '');
    }, [taggedAlonedReportee])

    const handleSubmit = async (e) => {
        e.preventDefault()
        let list = inputList[0]
        if (list['next_activity_type_id'] === '') {
            toast.error("Please choose activity type")
            return false
        }
        list['next_activity_date'] = currentDate
        if (list['next_activity_date'] === '') {
            toast.error("Please choose next activity date")
            return false
        }

        list['lead_id'] = match?.params?.lead_id
        list['lat'] = islatlng?.lat
        list['long'] = islatlng?.lng
        list['reason'][0]['primary_product'] = reason
        list['reason'][0]['add_on_product'] = addonProduct
        if (list['long'] == null || list['lat'] == null) {
            toast.error('Please enable your location');
            return false
        }

        if (isActivityCreated && list['next_activity_type_id'] !== '') {
            toast.error("Please complete your pending activity before creating new one.")
            return false
        }
        // console.log("listlistlist "+JSON.stringify(list))
        // return false
        setIsLoading(true)
        await saveActivity(list)
        setIsLoading(false)
    }

    const handleAddReason = () => {
        setReason([
            ...reason,
            {reason: ''}
        ])
    }

    const handleRemoveReason = (e, index) => {
        e.preventDefault()
        const list = [...reason]
        list.splice(index, 1);
        setReason(list);
    }

    const handleReason = (val, i, e) => {
        let list = [...reason]

        let isProduct = false
        reason.map((value, i) => {
            if (value?.reason === val) {
                isProduct = true
            }
        })
        if (isProduct) {
            handleRemoveReason(e, i)
            toast.warning(val + " already added in primary product")
            return false
        }

        list[i]['reason'] = val
        setReason(list)
    }

    const handleAddOnProduct = () => {
        setAddonProduct([
            ...addonProduct,
            {reason: ''}
        ])
    }

    const handleRemoveAddOnProduct = (e, index) => {
        e.preventDefault()
        const list = [...addonProduct]
        list.splice(index, 1);
        setAddonProduct(list);
    }

    const handleNewAddonProduct = (val, i, e) => {
        let list = [...addonProduct]

        let isProduct = false
        addonProduct.map((value, i) => {
            if (value?.reason === val) {
                isProduct = true
            }
        })
        if (isProduct) {
            handleRemoveAddOnProduct(e, i)
            toast.warning(val + " already added in add on product")
            return false
        }

        list[i]['reason'] = val
        setAddonProduct(list)
    }

    useEffect(() => {
        if (pendingActivity?.data !== null && pendingActivity?.data !== undefined && Object.keys(pendingActivity?.data).length > 0) {
            setIsActivityCreated(true)
        }
    }, [pendingActivity])

    useEffect(() => {
        if (isCheckoutDetails?.data !== null && isCheckoutDetails?.data !== undefined && Object.keys(isCheckoutDetails?.data).length > 0) {
            setOpenCheckIn(true)
            setCheckInText("Check out")
        }
    }, [isCheckoutDetails, pendingActivity])

    useEffect(() => {

        if (pendingActivity?.data !== null && pendingActivity?.data !== undefined && Object.keys(pendingActivity?.data).length > 0) {
            (async () => {
                setIsActivityCreated(true)
                setIsLoading(true)
                await isCheckout('BA', pendingActivity?.data?.account_id)
                setIsLoading(false)
            })()
        }
    }, [pendingActivity])

    useEffect(() => {
        // after check in hide popup
        if (attendance?.data !== undefined && attendance?.status === 200) {
            toast.success("Attendance is marked successfully")
            setOpenCheckIn(false)
        }else{
            toast.warning(attendance?.message)
        }
    }, [attendance, pendingActivity])

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={saveActivityRes?.message}
                url={`ba-activity-list/${match?.params?.lead_id}`}
            />

            <FailedModal
                isOpen={isFailedModalOpen}
                msg={saveActivityRes?.message}
                countToOpenModal={countToOpenModal}
            />
            <Loader isLoading={isLoading}/>

            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"Activity"}
                            history={history}
                        />
                        {/*BODY*/}

                        <div className="container-fluid common-bg">
                            {openCheckIn ?
                                <div className="box">
                                    <DistanceCalculator
                                        isMapShow={true}
                                        calculateDistance={markAttendance}
                                        moduleType={'BA'}
                                        checkInText={checkInText}
                                        checkoutId={isCheckoutDetails?.data !== undefined ? isCheckoutDetails?.data?.id : 0}
                                        activityId={isCheckoutDetails?.data?.activity_id !== undefined ? isCheckoutDetails?.data?.activity_id : ""}
                                        accountId={isCheckoutDetails?.data?.account_id !== undefined ? isCheckoutDetails?.data?.account_id : ""}
                                        documentUploadUrlPublic={documentUploadUrlPublic}
                                        documentUrlDataPublic={documentUrlDataPublic}
                                    />
                                </div> :
                                <>
                                    <form onSubmit={(e) => handleSubmit(e)}>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    {/*<h1 className="h3 mb-0 text-black-100">*/}
                                                    {/*    <span style={{color: "green"}}>{distance}</span>*/}
                                                    {/*</h1>*/}
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-1 float-field"
                                                                 style={{marginTop: "16px !important"}}>
                                                                <select
                                                                    className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        handleInput('next_activity_type_id', e.target.value, e)
                                                                        setActivityTypeId(e.target.value)
                                                                    }}>
                                                                    <option value="">Select Activity</option>
                                                                    {activityTypesDetails && activityTypesDetails?.data !== undefined && activityTypesDetails?.data.map((val) => {
                                                                        return (
                                                                            <>
                                                                                {parseInt(activityTypeId) === val?.id ?

                                                                                    <option
                                                                                        value={val?.id}
                                                                                        selected={true}>{val.name}
                                                                                    </option> :
                                                                                    <option
                                                                                        value={val?.id}>{val.name}
                                                                                    </option>
                                                                                }
                                                                            </>
                                                                        )
                                                                    })}
                                                                </select>
                                                                <label className="large-label float-lb">
                                                                    Schedule Activity
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mtk-075 float-field">
                                                                <input type="datetime-local"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput('next_activity_date', e.target.value, e)
                                                                           setCurrentDate(e.target.value)
                                                                       }}
                                                                       my-date-format={"DD/MM/YYYY, HH:mm:ss"}
                                                                       id="validationCustom01"
                                                                       min={new Date().toISOString().split('T')[0] + "T00:00"}
                                                                       value={currentDate}
                                                                       disabled={parseInt(activityTypeId) === 16}
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Activity Date
                                                                </label>
                                                            </div>
                                                            {reason.map((val, i) => {
                                                                return (
                                                                    <>
                                                                        <div className="col-sm-6 mt-1 float-field">
                                                                            <select
                                                                                className="form-control form-control-user"
                                                                                onChange={(e) => {
                                                                                    handleReason(e.target.value, i, e)
                                                                                }}
                                                                            >
                                                                                <option value="">Select Primary Products
                                                                                </option>
                                                                                <option
                                                                                    value={"Full gate with 1 Reader"}>Full gate with 1 Reader
                                                                                </option>
                                                                                <option
                                                                                    value={"Full gate with 2 Readers"}>Full gate with 2 Readers
                                                                                </option>
                                                                                <option
                                                                                    value={"Integration gate with 1 Reader"}>Integration gate with 1 Reader
                                                                                </option>
                                                                                <option
                                                                                    value={"Integration gate with 2 Readers"}>Integration gate with 2 Readers
                                                                                </option>
                                                                                <option
                                                                                    value={"Traffic Light "}>Traffic Light
                                                                                </option>
                                                                                <option
                                                                                    value={"Hooter"}>Hooter
                                                                                </option>
                                                                                <option
                                                                                    value={"Traffic Light + Hooter Combo "}>Traffic Light + Hooter Combo
                                                                                </option>
                                                                                <option
                                                                                    value={"LED"}>LED
                                                                                </option>
                                                                                <option
                                                                                    value={"ANPR - Existing park+ Full Gate + Camera + Software"}>ANPR - Existing park+ Full Gate + Camera + Software
                                                                                </option>
                                                                                <option
                                                                                    value={"ANPR - Existing park+ Visitor Gate + Camera + Software + Controller+ Pole"}>ANPR - Existing park+ Visitor Gate + Camera + Software + Controller+ Pole
                                                                                </option>
                                                                                <option
                                                                                    value={"Inventory flow (per LED per Gate)"}>Inventory flow (per LED per Gate)
                                                                                </option>
                                                                                <option
                                                                                    value={"RFID Tags"}>RFID Tags
                                                                                </option>
                                                                                <option
                                                                                    value={"Reader"}>Reader
                                                                                </option>
                                                                                <option
                                                                                    value={"Opex to capex"}>Opex to Capex
                                                                                </option>
                                                                                <option
                                                                                    value={"AMC Renewal"}>AMC Renewal
                                                                                </option>
                                                                                <option
                                                                                    value={"Addons"}>Addons
                                                                                </option>
                                                                                <option
                                                                                    value={"PGS"}>PGS
                                                                                </option>
                                                                                <option
                                                                                    value={"Manpower"}>Manpower
                                                                                </option>
                                                                                <option
                                                                                    value={"Parking Discovery"}>Parking Discovery
                                                                                </option>
                                                                                <option
                                                                                    value={"Valet"}>Valet
                                                                                </option>
                                                                                <option
                                                                                    value={"Visitor Gate"}>Visitor Gate
                                                                                </option>
                                                                                <option
                                                                                    value={"FITkit Tags"}>FITkit Tags
                                                                                </option>
                                                                                <option
                                                                                    value={"TVM"}>TVM
                                                                                </option>

                                                                            </select>
                                                                            <label className="large-label float-lb">
                                                                                Primary Products
                                                                            </label>
                                                                        </div>

                                                                        <div className="btn-box mb-2">
                                                                            {reason.length !== 1 &&
                                                                                <>
                                                                                    <button
                                                                                        onClick={(e) => handleRemoveReason(e, i)}
                                                                                        className="btn btn-sm btn-danger ml-3 mb-3 btn-ar">Remove
                                                                                        Primary Products
                                                                                    </button>
                                                                                </>
                                                                            }
                                                                            {reason.length - 1 === i &&
                                                                                <button type="button"
                                                                                        className="btn btn-sm btn-primary ml-3 btn-ar"
                                                                                        onClick={() => handleAddReason()}>Another
                                                                                    Primary Products
                                                                                </button>}
                                                                        </div>
                                                                    </>
                                                                )
                                                            })
                                                            }
                                                            {addonProduct.map((val, i) => {
                                                                return (
                                                                    <>
                                                                        <div className="col-sm-6 mt-1 float-field">
                                                                            <select
                                                                                className="form-control form-control-user"
                                                                                onChange={(e) => {
                                                                                    handleNewAddonProduct(e.target.value, i, e)
                                                                                }}
                                                                            >
                                                                                <option value="">Select Add on Products
                                                                                </option>
                                                                                <option
                                                                                    value={"Boom Arm Sleeve 4 meters "}>Boom Arm Sleeve 4 meters
                                                                                </option>
                                                                                <option
                                                                                    value={"Boom Arm Sleeve 24 inch "}>Boom Arm Sleeve 24 inch
                                                                                </option>
                                                                                <option
                                                                                    value={"Abs Reflective Road Stud"}>Abs Reflective Road Stud
                                                                                </option>
                                                                                <option
                                                                                    value={"Center Verge Lane Diving"}>Center Verge Lane Diving
                                                                                </option>
                                                                                <option
                                                                                    value={"Convex Mirror - 60 cm without pole "}>Convex Mirror - 60 cm without pole
                                                                                </option>
                                                                                <option
                                                                                    value={"Convex Mirror - 80 cm without pole "}>Convex Mirror - 80 cm without pole
                                                                                </option>
                                                                                <option
                                                                                    value={"Convex Mirror - 100 cm without pole "}>Convex Mirror - 100 cm without pole
                                                                                </option>
                                                                                <option
                                                                                    value={"End cap for speed breaker"}>End cap for speed breaker
                                                                                </option>
                                                                                <option
                                                                                    value={"Flap Delineator"}>Flap Delineator
                                                                                </option>
                                                                                <option
                                                                                    value={"Flexible City Bollards Post"}>Flexible City Bollards Post
                                                                                </option>
                                                                                <option
                                                                                    value={"Heavy Duty Corner Guard"}>Heavy Duty Corner Guard
                                                                                </option>
                                                                                <option
                                                                                    value={"Hexagonal Safety Cones"}>Hexagonal Safety Cones
                                                                                </option>
                                                                                <option
                                                                                    value={"Hexagonal Safety Cones - with Solar Flasher "}>Hexagonal Safety Cones - with Solar Flasher
                                                                                </option>
                                                                                <option
                                                                                    value={"Hexagonal Safety Cones - with Message Plate "}>Hexagonal Safety Cones - with Message Plate
                                                                                </option>
                                                                                <option
                                                                                    value={"HIP Reflective Tape  2\" x 50 m"}>HIP Reflective Tape  2" x 50 m
                                                                                </option>
                                                                                <option
                                                                                    value={"Indoor Glow-in - Dark Sign Boards"}>Indoor Glow-in - Dark Sign Boards
                                                                                </option>
                                                                                <option
                                                                                    value={"Light Baton Bar - Battery Operated"}>Light Baton Bar - Battery Operated
                                                                                </option>
                                                                                <option
                                                                                    value={"Light Baton Bar - Rechargeable"}>Light Baton Bar - Rechargeable
                                                                                </option>
                                                                                <option
                                                                                    value={"Linear Delineation System "}>Linear Delineation System
                                                                                </option>
                                                                                <option
                                                                                    value={"Lockable Parking Post "}>Lockable Parking Post
                                                                                </option>
                                                                                <option
                                                                                    value={"MS  wheel clamp lock LMV - anti- theft lock "}>MS  wheel clamp lock LMV - anti- theft lock
                                                                                </option>
                                                                                <option
                                                                                    value={"Outdoor Reflective Sign Boards"}>Outdoor Reflective Sign Boards
                                                                                </option>
                                                                                <option
                                                                                    value={"Plastic Chain - 10m (4mm)"}>Plastic Chain - 10m (4mm)
                                                                                </option>
                                                                                <option
                                                                                    value={"Plastic Chain - 10m (6mm)"}>Plastic Chain - 10m (6mm)
                                                                                </option>
                                                                                <option
                                                                                    value={"Plastic Chain - 10m (8mm)"}>Plastic Chain - 10m (8mm)
                                                                                </option>
                                                                                <option
                                                                                    value={"Plastic Chain Connector"}>Plastic Chain Connector
                                                                                </option>
                                                                                <option
                                                                                    value={"Plastic Chain Hook"}>Plastic Chain Hook
                                                                                </option>
                                                                                <option
                                                                                    value={"Plastic Collapsible Road Barrier"}>Plastic Collapsible Road Barrier
                                                                                </option>
                                                                                <option
                                                                                    value={"Plastic Rumbler Strip"}>Plastic Rumbler Strip
                                                                                </option>
                                                                                <option
                                                                                    value={"Plastic Speed Breaker"}>Plastic Speed Breaker
                                                                                </option>
                                                                                <option
                                                                                    value={"Plastic Water Filled Road Barrier"}>Plastic Water Filled Road Barrier
                                                                                </option>
                                                                                <option
                                                                                    value={"Plastic Wheel Stopper"}>Plastic Wheel Stopper
                                                                                </option>
                                                                                <option
                                                                                    value={"Pole for Convex Mirror"}>Pole for Convex Mirror
                                                                                </option>
                                                                                <option
                                                                                    value={"Pole for Signage"}>Pole for Signage
                                                                                </option>
                                                                                <option
                                                                                    value={"Private Parking Kit with Remote"}>Private Parking Kit with Remote
                                                                                </option>
                                                                                <option
                                                                                    value={"Reflective Tapes 2\" x 150ft"}>Reflective Tapes 2" x 150ft
                                                                                </option>
                                                                                <option
                                                                                    value={"Retractable Reel Pulley Yoyo for RFID Card Holder "}>Retractable Reel Pulley Yoyo for RFID Card Holder
                                                                                </option>
                                                                                <option
                                                                                    value={"RFID Card Holder"}>RFID Card Holder
                                                                                </option>
                                                                                <option
                                                                                    value={"Rubberised Corner Guard"}>Rubberised Corner Guard
                                                                                </option>
                                                                                <option
                                                                                    value={"Rubberised Wheel Stopper "}>Rubberised Wheel Stopper
                                                                                </option>
                                                                                <option
                                                                                    value={"Safety Cones - 3.8KG "}>Safety Cones - 3.8KG
                                                                                </option>
                                                                                <option
                                                                                    value={"Safety Cones - 4.8 Kg "}>Safety Cones - 4.8 Kg
                                                                                </option>
                                                                                <option
                                                                                    value={"Spring Post "}>Spring Post
                                                                                </option>
                                                                                <option
                                                                                    value={"Ultraflex Spring Post"}>Ultraflex Spring Post
                                                                                </option>
                                                                                <option
                                                                                    value={"Wall Mounted Clamp for Convex Mirror"}>Wall Mounted Clamp for Convex Mirror
                                                                                </option>
                                                                                <option
                                                                                    value={"Warning Bollard "}>Warning Bollard
                                                                                </option>
                                                                                <option
                                                                                    value={"Warning Bollard - with printed sticker "}>Warning Bollard - with printed sticker
                                                                                </option>
                                                                                <option
                                                                                    value={"Wire Connecting Rods"}>Wire Connecting Rods
                                                                                </option>
                                                                                <option
                                                                                    value={"Warning Barricading Bollard"}>Warning Barricading Bollard
                                                                                </option>
                                                                            </select>
                                                                            <label className="large-label float-lb">
                                                                                Add-on Products
                                                                            </label>
                                                                        </div>

                                                                        <div className="btn-box mb-2">
                                                                            {addonProduct.length !== 1 &&
                                                                                <>
                                                                                    <button
                                                                                        onClick={(e) => handleRemoveAddOnProduct(e, i)}
                                                                                        className="btn btn-sm btn-danger ml-3 mb-3 btn-ar">Remove
                                                                                        Remove Add-on Products
                                                                                    </button>
                                                                                </>
                                                                            }
                                                                            {addonProduct.length - 1 === i &&
                                                                                <button type="button"
                                                                                        className="btn btn-sm btn-primary ml-3  btn-ar"
                                                                                        onClick={() => handleAddOnProduct()}>Another
                                                                                    Add-on Products
                                                                                </button>}
                                                                        </div>
                                                                    </>
                                                                )
                                                            })
                                                            }
                                                            <div className="col-sm-6 mtk-075 float-field mb-4">
                                                                <DropDownInput
                                                                    data={senior}
                                                                    label={'Tagged Along'}
                                                                    getIdValue={(val) => {
                                                                        setTaggedAlonedReportee(val)
                                                                    }}
                                                                    multipule={true}
                                                                />
                                                            </div>
                                                            <div className="col-sm-6 mtk-075 float-field mb-4">
                                                            <textarea
                                                                className="form-control form-control-user"
                                                                placeholder=" Description"
                                                                onChange={(e) => {
                                                                    handleInput('description', e.target.value, '', e)
                                                                }}
                                                                id="validationCustom01"
                                                                rows="4" cols="50"
                                                                required={true}
                                                            />
                                                                <label className="large-label float-lb">
                                                                    {/*Description*/}
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-12 mtk-1 float-field mb-3 d-mtk-2">
                                                                <FileUpload
                                                                    id={"addAttachment"}
                                                                    accept=".png,.jpg,.jpeg"
                                                                    documentUploadUrl={documentUploadUrlPublic}
                                                                    documentUrlData={documentUrlDataPublic}
                                                                    onChange={(e, val) => {
                                                                        handleInput('meta_data', e, 'Document', e)
                                                                    }}
                                                                    prefilledFilename={""}
                                                                    multiple={true}
                                                                >
                                                                    File Attachment
                                                                </FileUpload>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*</div>*/}
                                                <div className="col-md-12 mt-4 d-flex">
                                                    <button className="btn btn-primary btn-user btn-block submit-btn">
                                                        Submit
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BAActivitySave

